import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from '@rogers/cdk/icon';

@Component({
  standalone: true,
  imports: [CommonModule, IconModule],
  selector: 'ucx-post-escalation-button',
  templateUrl: './post-escalation-button.component.html',
  styleUrls: ['./post-escalation-button.component.scss'],
})
export class PostEscalationButtonComponent {
  @Input()
  iconType = '';

  @Input()
  productName = '';

  @Input()
  productDescription = '';

  @Input() onHandleClick;

  onButtonClick(): void {
    this.onHandleClick(this.productName);
  }
}
